// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-36cf4049].require > .el-input__inner {\n  border: red 1px solid;\n}", ""]);
// Exports
module.exports = exports;
